import BeautyInsiderSummary from 'components/Content/BeautyInsider/BeautyInsiderSummary/BeautyInsiderSummary';
import { withBeautyInsiderSummaryProps } from 'viewModel/content/BeautyInsider/BeautyInsiderSummary/withBeautyInsiderSummaryProps';

export default withBeautyInsiderSummaryProps(BeautyInsiderSummary);
